export default __webpack_public_path__ + "static/media/regulatoryIcon.09ebbd7b.svg";